import Rest from '../Rest'

/**
 * Operação financeira do programa de influencers do lado da Hubee.
 *
 * Um serviço só para carteiras, saques, comissões e liquidação porque todos
 * respondem pelo mesmo controller e compartilham o mesmo contexto de tela.
 */
export default class WalletAdminService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  // --- Comissões ---
  commissions(params: any = {}) {
    return this.get(`/commissions?${new URLSearchParams(params).toString()}`)
  }

  // --- Carteiras ---
  wallets(page = 1) {
    return this.get(`/wallets?page=${page}`)
  }

  walletDetail(id: number) {
    return this.get(`/wallets/${id}`)
  }

  /** Passivo total em carteira e carteiras negativas. */
  liability() {
    return this.get('/wallets/liability')
  }

  adjust(id: number, amountCents: number, reason: string) {
    return this.post(`/wallets/${id}/adjust`, { amount_cents: amountCents, reason })
  }

  blockWallet(id: number, reason: string) {
    return this.put(`/wallets/${id}/block`, { reason })
  }

  unblockWallet(id: number) {
    return this.put(`/wallets/${id}/unblock`, {})
  }

  // --- Saques ---
  /**
   * `statuses` vira um par `status[]` por valor. `URLSearchParams` não expande
   * array sozinho — passar o array direto viraria `status=SO,AP` e o backend,
   * que faz `whereIn`, filtraria por uma string única inexistente.
   */
  withdrawals(statuses: string[] = []) {
    const params = new URLSearchParams()
    statuses.forEach(s => params.append('status[]', s))

    return this.get(`/withdrawals?${params.toString()}`)
  }

  approveWithdrawal(id: number) {
    return this.put(`/withdrawals/${id}/approve`, {})
  }

  scheduleWithdrawal(id: number, scheduledFor: string) {
    return this.put(`/withdrawals/${id}/schedule`, { scheduled_for: scheduledFor })
  }

  payWithdrawal(id: number, externalReference: string, taxWithheldCents: number | null) {
    return this.put(`/withdrawals/${id}/pay`, {
      external_reference: externalReference,
      tax_withheld_cents: taxWithheldCents
    })
  }

  rejectWithdrawal(id: number, reason: string) {
    return this.put(`/withdrawals/${id}/reject`, { reason })
  }

  failWithdrawal(id: number, reason: string) {
    return this.put(`/withdrawals/${id}/fail`, { reason })
  }

  // --- Liquidação com o clube ---
  settlements(params: any = {}) {
    return this.get(`/wallet_settlements?${new URLSearchParams(params).toString()}`)
  }

  settle(id: number, externalReference: string) {
    return this.put(`/wallet_settlements/${id}/settle`, { external_reference: externalReference })
  }
}
